import { IArrowLeftProps } from "interfaces";

const ArrowLeftIcon = ({ className, onClick }: IArrowLeftProps) => {
    return (
        <svg width="25" height="25" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} onClick={onClick}>
            <path d="M10.3985 6.11212C10.401 6.3021 10.3336 6.49302 10.1856 6.64501L4.72013 12.2586L10.3337 17.724C10.6275 18.0101 10.6339 18.4901 10.3478 18.7839C10.0617 19.0778 9.58179 19.0842 9.28794 18.7981L3.13735 12.8098C2.8435 12.5237 2.83709 12.0437 3.12319 11.7499L9.11152 5.59927C9.39762 5.30542 9.87757 5.29901 10.1714 5.58511C10.3233 5.72309 10.3959 5.92214 10.3985 6.11212Z" />
            <path d="M21.4082 12.0363C21.4137 12.4463 21.0782 12.7908 20.6683 12.7963L3.83978 13.0212C3.42981 13.0267 3.0853 12.6913 3.07982 12.2813C3.07434 11.8714 3.40977 11.5268 3.81973 11.5214L20.6482 11.2964C21.0582 11.2909 21.4027 11.6264 21.4082 12.0363Z" />
        </svg>
    );
};

export default ArrowLeftIcon;
